import { useQueryClient } from '@tanstack/react-query'
import { useT } from '../lib/i18n'
import { Sheet } from './ui'
import SignIn from '../screens/SignIn'

/**
 * The sign-in, asked for at the only moment it buys anything.
 *
 * It used to stand at the door, before the person had seen a city, a price or
 * a vehicle. It now opens over the screen they are already on, at the step
 * that puts a request in front of transporters -- and when it closes, the
 * action they were taking CONTINUES. Dropping someone on a home screen to go
 * and find the button again is how a sign-in turns into an abandoned booking.
 *
 * The heading says why it is being asked for now. "Sign in" on its own, at a
 * step someone did not expect it, reads as a wall.
 */
export function SignInSheet({ open, onClose, onDone }: {
  open: boolean
  onClose: () => void
  /** Run the thing they were doing when they hit the gate. */
  onDone: () => void
}) {
  const msg = useT()
  const qc = useQueryClient()

  return (
    <Sheet open={open} onClose={onClose} full title={msg('guest.signIn')}>
      <div className="px-1 pb-2">
        <h2 className="font-display text-[19px] font-extrabold leading-tight">
          {msg('guest.needAccountTitle')}
        </h2>
        <p className="mt-1.5 text-[13px] leading-relaxed text-ink-3">
          {msg('guest.needAccountBody')}
        </p>
      </div>
      <SignIn onDone={() => {
        // Every query on this screen was made without a caller. Dropping them
        // is cheaper than reasoning about which ones now answer differently.
        void qc.invalidateQueries()
        onDone()
      }} />
    </Sheet>
  )
}
